import { gql } from '@apollo/client'

export const GET_SUMMARY_OF_BENEFITS = gql`
  query(
    $h_number: String!
    $plan_id: String!
    $segment_id: String
    $effective_date: DateTime
  ) {
    getSummaryOfBenefitsForUser(
      h_number: $h_number
      plan_id: $plan_id
      segment_id: $segment_id
      effective_date: $effective_date
    ) {
      planName
      carrier
      planSubType
      documents {
        Name
        LinkName
        Url
      }
    }
  }
`
